export class CptSearchRequest{
    feeScheduleId:string;
    searchCriteria:string;

    constructor(feeScheduleId:string, searchCriteria:string){
        this.feeScheduleId = feeScheduleId;
        this.searchCriteria = searchCriteria;
    }
}